<div class="header">
    <h2 mat-dialog-title>{{data.name}}</h2>
    <mat-dialog-actions>
        <button mat-icon-button color="primary" mat-dialog-close class="closeButton">
            <mat-icon>close</mat-icon>
        </button>
    </mat-dialog-actions>
</div>
<mat-dialog-content class="content">
    <div class="link">
        <div *ngIf="ecus.includes(data.name)">
            <button mat-stroked-button (click)="routToIO(data.canIds)" class="routBtn">
                <mat-icon class="icon">settings_input_composite</mat-icon>
                {{"BUS.PIN" | translate }}</button>
        </div>
        <div *ngIf="dtcEcus.includes(data.name)">
            <button mat-stroked-button (click)="routToDtc(data.canIds)" class="routBtn">
                <mat-icon class="icon">troubleshoot</mat-icon>
                {{"DTC.MENU" | translate }}</button>
        </div>  
    </div>
    <table mat-table [dataSource]="dataSource">

        <!-- CAN Column -->
        <ng-container matColumnDef="can">
            <th mat-header-cell *matHeaderCellDef>CAN</th>
            <td mat-cell *matCellDef="let element">CAN {{element.can}}</td>
        </ng-container>

        <!-- Member-ID Column -->
        <ng-container matColumnDef="member_id">
            <th mat-header-cell *matHeaderCellDef>{{"BUS.IDENTIFIERS" | translate }}</th>
            <td mat-cell *matCellDef="let element">{{element.member_id}}</td>
        </ng-container>

        <!-- State Column -->
        <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>{{"BUS.STATE" | translate }}</th>
            <td mat-cell *matCellDef="let element">
                <mat-chip [ngClass]="{
                    'undefine': element.state == 'not definable',
                    'okay': element.state == 'okay',
                    'error': element.state == 'error on can-member',
                    'unreach': element.state == 'not reachable',
                 }"></mat-chip> 
                {{element.state}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>

    </table>
</mat-dialog-content>